import React, { Component, Fragment } from 'react';

class Documents extends Component {
  shouldComponentUpdate(prevProps) {
    return prevProps.title !== this.props.title;
  }

  render() {
    const { title, documents } = this.props;
    return (
      <Fragment>
        <h1 className="title">{title}</h1>
        {documents.map(({ href, text }) =>
          <p key={href} className="transitioned-fade-in"><a href={href} target="_blank">{text}</a></p>
        )}
      </Fragment>
    );
  }
}

export default Documents;



// WEBPACK FOOTER //
// ./src/presentational/Documents/index.js